// CapacitiveSensor.jsx
import React, { useState } from 'react';
import Header from './Header';
import Footer from './Footer';
import { FaFilePdf,FaChevronRight,FaEnvelope } from 'react-icons/fa';

import '../styles/CapacitiveSensor.css';
// import QuoteModal from './QuoteModal'; // Adjust path
import WhatsAppModal from './WhatsAppModal';


import CapacitiveSensorMain from '../assets/CapacitiveSensorMain.png';

import capacitiveSpecsImg from '../assets/Capacitive Sensor Specification IMG.png';

import Capacitive1 from '../assets/Capacitive1.jpg';
import Capacitive2 from '../assets/Capacitive2.jpg';
import Capacitive3 from '../assets/Capacitive3.jpg';
import Capacitive4 from '../assets/Capacitive4.jpg';
import capacitivepdf from '../assets/Capacitive Sensor.pdf';
import CapacitiveSpecificationpdf from '../assets/Capacitive Sensor Specification.pdf';




import CapacitivesensorCKseriespdf from '../assets/Capacitive/Capacitive sensor_CK series.pdf';
import CapacitivesensorCWFseriespdf from '../assets/Capacitive/Cylindrical-Type-(CK-Series).pdf';
import CapacitivesensorCQseriespdf from '../assets/Capacitive/Capacitive sensor_CQ Series.pdf';
import LiquidLevelDetectionCEseriespdf from '../assets/Capacitive/Liquid Level Detection (CE series).pdf';



export default function CapacitiveSensor() {
  const [activeTab, setActiveTab] = useState('products');
  // const [showModal, setShowModal] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <div className="CapacitiveSensor-wrapper">
      <Header />

      <div className="hero-banner16">
        <div className="hero-banner16-content">
          <h1>CAPACITIVE SENSOR</h1>
          <div className="sensor-breadcrumb">
            <a href="/">Home</a> <FaChevronRight /> <span>Capacitive Sensor</span>
          </div>
        </div>
      </div>

      <div className="CapacitiveSensor-intro-wrap">
        <img src={CapacitiveSensorMain} alt="Capacitive Sensor" />
        <div className="CapacitiveSensor-description">
          <h2>Capacitive Sensor</h2>
          <ul>
            <li>High noise immunity</li>
            <li>Sensing range adjustable by means of potentiometer or teach button</li>
            <li>Plastic or metal housings for different applications</li>
            <li>Sensors for position and level detection</li>
            <li>Accessories for mounting on tanks or sight glasses</li>
            <li>Metal and plastic housings are available.</li>
            <li>IP67, water-proof and oil-proof.</li>
          </ul>
          <div className="sensor-buttons">
            <a href={capacitivepdf} target="_blank" rel="noopener noreferrer">
             <button className="download-catalog-btn"><FaFilePdf style={{ marginRight: '8px' }} /> Full Catalog Download</button>            
             </a>
          <button className="request-quote-btn" onClick={() => setIsModalOpen(true)}><FaEnvelope /> Request a Quote</button>
          {/* <QuoteModal isOpen={showModal} onClose={() => setShowModal(false)} /> */}
                {/* WhatsApp Modal */}
      <WhatsAppModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />

          </div>
        </div>
      </div>

      <div className="sensor-tabs">
        <button className={activeTab === 'products' ? 'active' : ''} onClick={() => setActiveTab('products')}>Capacitive Sensors Products</button>
        <button className={activeTab === 'specs' ? 'active' : ''} onClick={() => setActiveTab('specs')}>Technical Specifications</button>
      </div>

      <div className="sensor-product-section">
{activeTab === 'specs' && (
  <div className="capacitivespecs-image-wrapper">
    <img
      src={capacitiveSpecsImg} // Your specs image here
      alt="Capacitive Sensor Technical Specifications"
      className="capacitivespecs-img"
    />
    
    <div className="capacitivespecs-download-btn">
      <a
        href={CapacitiveSpecificationpdf}
        target="_blank"
        rel="noopener noreferrer"
      >
        <button className="download-catalog-btn">
          <FaFilePdf style={{ marginRight: '8px' }} /> Download
        </button>
      </a>
    </div>
  </div>
)}

        {activeTab === 'products' && (
          <div className="sensor-product-grid">
            <div className="sensor-card">
              <img src={Capacitive1} alt="CK Series" />
              <h4>Cylindrical Type (CK series)</h4>
              <ul>
                <li>Detect metal, plastic and liquid, etc</li>
                <li>With reverse polarity, short circuit, surge and many other protection functions</li>
                <li>Metal and plastic housings are available</li>
              </ul>
              <a href={CapacitivesensorCKseriespdf} target="_blank" rel="noopener noreferrer">
                <button className="download-catalog-btn"><FaFilePdf style={{ marginRight: '8px' }} /> Download</button>
              </a>
            </div>
            <div className="sensor-card">
              <img src={Capacitive2} alt="CWF Series" />
              <h4>Corrosion Resistant Type (CWF series)</h4>
              <ul>
                <li>Up to 20 turns sensitivity adjustment</li>
                <li>Teflon coatings ensure superior corrosion resistance</li>
                <li>Widely used in detection of metals, water, oil, glasses, plastic and water, etc</li>
              </ul>
              <a href={CapacitivesensorCWFseriespdf} target="_blank" rel="noopener noreferrer">
                <button className="download-catalog-btn"><FaFilePdf style={{ marginRight: '8px' }} /> Download</button>
              </a>
            </div>
            <div className="sensor-card">
              <img src={Capacitive3} alt="CQ Series" />
              <h4>Flat Type (CQ series)</h4>
              <ul>
                <li>7mm of thickness only for saving space</li>
                <li>Enjoy stability; comparable to world famous brands</li>
                <li>Offer different kinds of sensing distance of 5mm, 6mm, 7mm and 10mm, etc</li>
              </ul>
              <a href={CapacitivesensorCQseriespdf} target="_blank" rel="noopener noreferrer">
                <button className="download-catalog-btn"><FaFilePdf style={{ marginRight: '8px' }} /> Download</button>
              </a>
            </div>
            <div className="sensor-card">
              <img src={Capacitive4} alt="CE Series" />
              <h4>Liquid Level Detection (CE series)</h4>
              <ul>
                <li>Free from influence of liquid color in pipeline</li>
                <li>Suitable for pipeline diameter from 8mm to 11mm, 12mm to 26mm</li>
                <li>With built-in amplifier to save installing space</li>
              </ul>
              <a href={LiquidLevelDetectionCEseriespdf} target="_blank" rel="noopener noreferrer">
                <button className="download-catalog-btn"><FaFilePdf style={{ marginRight: '8px' }} /> Download</button>
              </a>
            </div>
          

          </div>
        )}
          <br/>
      <br/>
      </div>
      <Footer />

    </div>
  );
}
